// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"e344b98b","340":"fa354d0c","569":"0badb158","570":"94a7f3e2","788":"3e654298"}[chunkId] + ".chunk.css";
};